import React from 'react';
import {
  Card,
  CardText,
  CardHeader,
  List,
  ListItem,
} from 'material-ui';
import ProfileIcon from 'material-ui/svg-icons/social/person';
import groupBy from 'lodash/groupBy';
import {
  translate as t,
} from 'admin-on-rest';

const TRANSLATION_PREFIX = 'documents.files';
const BasicListItem = ({ children, ...props }) => (
  <ListItem
    hoverColor="none"
    style={{ display: 'flex', alignItems: 'center' }}
    {...props}
  >
    {children}
  </ListItem>
);

class AcknowledgmentHistory extends React.Component {
  render() {
    const { history, translate } = this.props;
    const usersLexicallyByVenue = groupBy(
      history
        // Sort by lexically by fullName
        .sort((a, b) => {
          const A = (a.name || '').toUpperCase();
          const B = (b.name || '').toUpperCase();
          if (A < B) {
            return -1;
          }
          if (A > B) {
            return 1;
          }
          return 0;
        })
        // Extract a user object for every user venue
        // (map first then flatten)
        .flatMap(({ venues, ...user }) => venues.map((venue) => ({
          ...user,
          venue,
        }))),
      (u) => u.venue.name
    );
    const usersWithNoVenue = history.filter((user) => user.venues.length < 1);
    const usersWithNoVenueKey = translate(`${TRANSLATION_PREFIX}.noVenue`);
    const sortedVenues = Object.keys(usersLexicallyByVenue).sort();
    if (usersWithNoVenue.length > 0) {
      usersLexicallyByVenue[usersWithNoVenueKey] = usersWithNoVenue;
      sortedVenues.push(usersWithNoVenueKey);
    }
    return (
      <Card>
        <CardHeader
          title={`${translate(`${TRANSLATION_PREFIX}.read`)} ${history.length || 0} ${translate(`${TRANSLATION_PREFIX}.times`)}`}
          actAsExpander
          showExpandableButton
        />
        <CardText expandable>
          <List
            style={{
              maxHeight: '420px',
              overflowY: 'scroll',
            }}
          >
            {
              sortedVenues.map((venue) => (
                <BasicListItem key={venue}>
                  <h4 style={{ margin: 0 }}>{venue}</h4>
                  <List>
                    {
                      usersLexicallyByVenue[venue].map((u) => (
                        <BasicListItem
                          key={u.userId}
                          primaryText={u.name}
                          leftIcon={<ProfileIcon />}
                        />
                      ))
                    }
                  </List>
                </BasicListItem>
              ))
            }
          </List>
        </CardText>
      </Card>
    );
  }
}

export default t(AcknowledgmentHistory);
